import { render, staticRenderFns } from "./NewContentButton.vue?vue&type=template&id=be69b64a"
import script from "./NewContentButton.vue?vue&type=script&lang=js"
export * from "./NewContentButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports